<script setup>

import Icon from '@/components/Icon/Icon.vue'
import { useSettingStore } from '@/store/setting.store'

const props = defineProps({
    active: String,
    required: false,
    default: '',
})

const settingStore = useSettingStore()

const toggleSize = () => settingStore.large = !settingStore.large

const size = () => {
    if(settingStore.large) {
        return "m-4 w-64 transition-all duration-300"
    }

    return "mx-2 my-4 w-14 transition-all duration-300"
}

const displayText = () => {
    if(settingStore.large) {
        return "opacity-100 delay-200"
    }

    return "opacity-0 delay-0"
}

const isActive = (index) => {
    if(index == props.active) {
        return 'ml-3 bg-rose-500'
    }

    return 'transition ease-in-out hover:translate-x-3 hover:bg-rose-500'
}

</script>

<template>
    <div class="m-2">
        <button v-if="settingStore.large" @click="toggleSize()" class="border rounded p-0 cursor-pointer">
            <Icon name="backward" color="grey" class="m-2 w-5 h-5" />
        </button>
        <button v-else @click="toggleSize()" class="border rounded p-0 cursor-pointer">
            <Icon name="forward" color="grey" class="m-2 w-5 h-5" />
        </button>
    </div>
    <div class="overflow-hidden" :class="size()">
        <nav>
            <ul class="flex flex-col gap-2">
                <li :class="isActive('main')">
                    <router-link :to="{name: 'main'}" title="Tableau de bord" class="flex m-0">
                        <div class="flex my-1 before:bg-rose-500 before:p-1">
                            <Icon name="dashboard" color="black" class="m-2 w-4 h-4" />
                            <span class="my-auto whitespace-nowrap" :class="displayText()">Tableau de bord</span>
                        </div>
                    </router-link>
                </li>
                <li :class="isActive('task')">
                    <router-link :to="{name: 'task'}" title="Tâches" class="flex m-0">
                        <div class="flex my-1 before:bg-rose-500 before:p-1">
                            <Icon name="task" color="black" class="m-2 w-4 h-4" />
                            <span class="my-auto whitespace-nowrap" :class="displayText()">Tâches</span>
                        </div>
                    </router-link>
                </li>
                <li :class="isActive('property')">
                    <router-link :to="{name: 'property'}" title="Biens" class="flex m-0">
                        <div class="flex my-1 before:bg-rose-500 before:p-1">
                            <Icon name="properties" color="black" class="m-2 w-4 h-4" />
                            <span class="my-auto whitespace-nowrap" :class="displayText()">Biens</span>
                        </div>
                    </router-link>
                </li>
                <li :class="isActive('renting')">
                    <router-link :to="{name: 'renting'}" title="Locations" class="flex m-0">
                        <div class="flex my-1 before:bg-rose-500 before:p-1">
                            <Icon name="key" color="black" class="m-2 w-4 h-4" />
                            <span class="my-auto whitespace-nowrap" :class="displayText()">Locations</span>
                        </div>
                    </router-link>
                </li>
                <li :class="isActive('financier')">
                    <router-link :to="{name: 'financier'}" title="Financier" class="flex m-0">
                        <div class="flex my-1 before:bg-rose-500 before:p-1">
                            <Icon name="coin" color="black" class="m-2 w-4 h-4" />
                            <span class="my-auto whitespace-nowrap" :class="displayText()">Financier</span>
                        </div>
                    </router-link>
                </li>
                <li :class="isActive('tenant')">
                    <router-link :to="{name: 'tenant'}" title="Locataires" class="flex m-0">
                        <div class="flex my-1 before:bg-rose-500 before:p-1">
                            <Icon name="tenants" color="black" class="m-2 w-4 h-4" />
                            <span class="my-auto whitespace-nowrap" :class="displayText()">Locataires</span>
                        </div>
                    </router-link>
                </li>
                <li :class="isActive('expense')">
                    <div class="flex my-1 before:bg-rose-500 before:p-1">
                        <router-link :to="{name: 'expense'}" title="Dépenses" class="flex m-0">
                            <Icon name="expense" color="black" class="m-2 w-4 h-4" />
                            <span class="my-auto whitespace-nowrap" :class="displayText()">Dépenses</span>
                        </router-link>
                    </div>
                </li>
                <li :class="isActive('balance_sheet')">
                    <div class="flex my-1 before:bg-rose-500 before:p-1">
                        <router-link :to="{name: 'balance_sheet'}" title="Bilan" class="flex m-0">
                            <Icon name="balance_sheet" color="black" class="m-2 w-4 h-4" />
                            <span class="my-auto whitespace-nowrap" :class="displayText()">Bilan</span>
                        </router-link>
                    </div>
                </li>
                <li :class="isActive('bank_account')">
                    <div class="flex my-1 before:bg-rose-500 before:p-1">
                        <router-link :to="{name: 'bank_account'}" title="Banques" class="flex m-0">
                            <Icon name="bank" color="black" class="m-2 w-4 h-4" />
                            <span class="my-auto whitespace-nowrap" :class="displayText()">Comptes bancaires</span>
                        </router-link>
                    </div>
                </li>
                <li :class="isActive('legal_structure')">
                    <div class="flex my-1 before:bg-rose-500 before:p-1">
                        <router-link :to="{name: 'legal_structure'}" title="Organismes juridiques" class="flex m-0">
                            <Icon name="structure_legal" color="black" class="m-2 w-4 h-4" />
                            <span class="my-auto whitespace-nowrap" :class="displayText()">Organismes juridiques</span>
                        </router-link>
                    </div>
                </li>
                <li :class="isActive('owner')">
                    <div class="flex my-1 before:bg-rose-500 before:p-1">
                        <router-link :to="{name: 'owner'}" title="Propriétaires" class="flex m-0">
                            <Icon name="owner" color="black" class="m-2 w-4 h-4" />
                            <span class="my-auto whitespace-nowrap" :class="displayText()">Propriétaires</span>
                        </router-link>
                    </div>
                </li>
            </ul>
        </nav>
    </div>
</template>
